import {DataTableColumn} from "mantine-datatable";
import {BindingDriftReportSummary} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {RunHealthBadge} from "../profile/Badges.tsx";
import {formatTimestamp, TIMESTAMP_PLACEHOLDER} from "../../../utils/TableTimestamps.tsx";

export const useBindingDriftReportsTableColumns = () => {

    const columns: DataTableColumn<BindingDriftReportSummary>[] = [
        {
            accessor: 'runStartedAt',
            title: I18n.get('Run Started'),
            width: '1fr',
            sortable: true,
            render: (item) => item.runStartedAt ? formatTimestamp(item.runStartedAt) : TIMESTAMP_PLACEHOLDER,
        },
        {
            accessor: 'accountsScanned',
            title: I18n.get('Accounts Scanned'),
            width: '1fr',
            sortable: true,
            render: (item) => item.accountsScanned ?? 0,
        },
        {
            accessor: 'driftDetectedCount',
            title: I18n.get('Drift Detected'),
            width: '1fr',
            sortable: true,
            render: (item) => item.driftDetectedCount ?? 0,
        },
        {
            accessor: 'repairedCount',
            title: I18n.get('Repaired'),
            width: '1fr',
            sortable: true,
            render: (item) => item.repairedCount ?? 0,
        },
        {
            accessor: 'repairFailedCount',
            title: I18n.get('Repair Failed'),
            width: '1fr',
            sortable: true,
            render: (item) => item.repairFailedCount ?? 0,
        },
        {
            accessor: 'repairCappedCount',
            title: I18n.get('Repair Capped'),
            width: '1fr',
            sortable: true,
            render: (item) => item.repairCappedCount ?? 0,
        },
        {
            // NOT sortable, deliberately. Status is not a field on the record: the
            // badge derives it from the repair counts (utils/runHealth.ts). The shared
            // sort reads record[accessor], so a sortable header here would sort on
            // undefined and do nothing. To find the runs that need attention, sort by
            // Repair Failed or Repair Capped.
            accessor: 'status',
            title: I18n.get('Status'),
            sortable: false,
            width: '1fr',
            render: (item) => <RunHealthBadge record={item}/>,
        },
    ];

    return {
        columns,
    }
}
